/* UI interactions: mobile nav, scroll reveal, floating sidebar */
// Mobile nav toggle
const menuToggle = document.getElementById('menu-toggle');
const mobileNav = document.getElementById('mobile-nav');
if (menuToggle && mobileNav) {
  const mobileClose = document.getElementById('mobile-close');
  const mobileLinks = [...mobileNav.querySelectorAll('a')];
  const setMobileNav = (isOpen, returnFocus = false) => {
    menuToggle.classList.toggle('active', isOpen);
    mobileNav.classList.toggle('active', isOpen);
    menuToggle.setAttribute('aria-expanded', String(isOpen));
    menuToggle.setAttribute('aria-label', isOpen ? '關閉選單' : '開啟選單');
    mobileNav.setAttribute('aria-hidden', String(!isOpen));
    document.body.classList.toggle('mobile-nav-open', isOpen);

    if (isOpen) {
      window.requestAnimationFrame(() => (mobileClose || mobileLinks[0])?.focus());
    } else if (returnFocus) {
      menuToggle.focus();
    }
  };

  menuToggle.setAttribute('aria-controls', 'mobile-nav');
  setMobileNav(false);
  menuToggle.addEventListener('click', () => setMobileNav(!mobileNav.classList.contains('active')));

  if (mobileClose) {
    mobileClose.addEventListener('click', () => setMobileNav(false, true));
  }
  mobileLinks.forEach(link => {
    link.addEventListener('click', () => setMobileNav(false));
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && mobileNav.classList.contains('active')) {
      setMobileNav(false, true);
    }
  });
}

// Homepage header stays readable while following the page.
const homeHeader = document.querySelector('.home-header');
if (homeHeader) {
  const syncHomeHeader = () => homeHeader.classList.toggle('is-scrolled', window.scrollY > 24);
  syncHomeHeader();
  window.addEventListener('scroll', syncHomeHeader, { passive: true });
}

// Floating sidebar show after banner
const sidebar = document.querySelector('.floating-sidebar');
const pageTopBtn = document.querySelector('.btn-page-top');
if (sidebar) {
  window.addEventListener('scroll', () => {
    const bannerHeight = window.innerHeight;
    if (window.scrollY > bannerHeight - 100) {
      sidebar.classList.add('active');
    } else {
      sidebar.classList.remove('active');
    }
  });
}
if (pageTopBtn) {
  pageTopBtn.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}

// Scroll reveal
(function () {
  const revealElements = document.querySelectorAll('.reveal-on-scroll');
  if (revealElements.length === 0) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    revealElements.forEach(el => el.classList.add('is-visible'));
    return;
  }
  const observerOptions = { root: null, threshold: 0.15, rootMargin: '0px' };
  const revealObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);
  revealElements.forEach(el => revealObserver.observe(el));
})();

// 手機版讓 ISO 徽章與副標共用同一個流式排列容器，避免依賴固定 top 值；
// 回到桌機時再放回 footer，維持原本左下角的位置。
(function () {
  const isoBadge = document.querySelector('.iso-badge');
  const uiFooter = document.querySelector('.ui-layer > footer');
  const mobileSlot = document.querySelector('.mobile-iso-slot');
  const mobileQuery = window.matchMedia('(max-width: 768px), (max-width: 1024px) and (orientation: portrait)');
  if (!isoBadge || !uiFooter || !mobileSlot) return;
  function relocate() {
    if (mobileQuery.matches) {
      if (!mobileSlot.contains(isoBadge)) mobileSlot.appendChild(isoBadge);
    } else if (!uiFooter.contains(isoBadge)) {
      const scrollDown = uiFooter.querySelector('.scroll-down');
      if (scrollDown) uiFooter.insertBefore(isoBadge, scrollDown);
      else uiFooter.appendChild(isoBadge);
    }
    isoBadge.style.marginTop = '';
    isoBadge.style.alignSelf = '';
  }
  relocate();
  if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', relocate);
  else if (mobileQuery.addListener) mobileQuery.addListener(relocate);
})();

// Mobile service details opened from the interactive Three.js service nodes.
(function () {
  const modal = document.getElementById('service-detail-modal');
  if (!modal) return;
  const panel = modal.querySelector('.service-detail-panel');
  const closeButton = modal.querySelector('.service-detail-close');
  const eyebrow = document.getElementById('service-detail-eyebrow');
  const title = document.getElementById('service-detail-title');
  const line1 = document.getElementById('service-detail-line-1');
  const line2 = document.getElementById('service-detail-line-2');
  const meta = document.getElementById('service-detail-meta');
  let previousFocus = null;

  function closeModal() {
    if (!modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('service-modal-open');
    if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
  }

  function openModal(detail) {
    if (!detail || !window.matchMedia('(max-width: 768px), (max-width: 1024px) and (orientation: portrait)').matches) return;
    previousFocus = document.activeElement;
    eyebrow.textContent = detail.eyebrow || detail.service || '';
    title.textContent = detail.title || detail.service || '';
    line1.textContent = (detail.lines && detail.lines[0]) || '';
    line2.textContent = (detail.lines && detail.lines[1]) || '';
    meta.textContent = detail.meta || '';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('service-modal-open');
    requestAnimationFrame(() => {
      if (panel) panel.focus({ preventScroll: true });
    });
  }

  window.addEventListener('service-detail', (event) => openModal(event.detail));
  modal.addEventListener('click', (event) => {
    if (event.target.closest('[data-service-modal-close]')) closeModal();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeModal();
  });
  if (closeButton) closeButton.addEventListener('touchend', closeModal, { passive: true });
})();

// --- 🚀 數值衝刺動畫邏輯 ---
function animateCounters() {
  const counters = document.querySelectorAll('.counter');
  const speed = 150;
  counters.forEach(counter => {
    const updateCount = () => {
      const target = +counter.getAttribute('data-target');
      const count = +counter.innerText.replace(/,/g, '');
      const inc = target / speed;
      if (count < target) {
        const newValue = Math.ceil(count + inc);
        counter.innerText = newValue.toLocaleString();
        setTimeout(updateCount, 15);
      } else {
        counter.innerText = target.toLocaleString();
      }
    };
    updateCount();
  });
}

// Observe about-visuals (fallback to section-about)
(function () {
  const aboutVisuals = document.querySelector('.about-visuals');
  const aboutSection = document.querySelector('#section-about');
  const observerTarget = aboutVisuals || aboutSection;
  const observerOptions = { threshold: 0.15 };
  if (observerTarget) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateCounters();
          obs.unobserve(entry.target);
        }
      });
    }, observerOptions);
    observer.observe(observerTarget);
  } else {
    animateCounters();
  }
})();